export enum JobItemStatusEnum {
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
  Failure = 'FAILURE',
}

export enum JobStatusEnum {
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
  Failure = 'FAILURE',
}
